import { startAnalyticsEffect } from "@/core/effects/analyticsEffect";
import { startReloginContinuationEffect } from "@/core/effects/reloginEffect";
import { WidgetEvent$ } from "@/core";

let stopAll: null | (() => void) = null;

export const startWidgetEffects = () => {
  if (stopAll) return stopAll;

  const stops = [startAnalyticsEffect(), startReloginContinuationEffect()];

  if (import.meta.env.DEV || window.__KCW_DEBUG__) {
    console.log("[telekomId] effects started");

    WidgetEvent$.subscribe((e) => {
      console.log("🚀 ~ [telekomId:event]", e);
    });
  }

  stopAll = () => {
    stops.forEach((s) => s());
    stopAll = null;
  };

  return stopAll;
};
